"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FrontendAdcOverrideError = void 0;
var FrontendAdcOverrideError;
(function (FrontendAdcOverrideError) {
    FrontendAdcOverrideError["EXPIRED"] = "EXPIRED";
    FrontendAdcOverrideError["ALREADY_ANSWERED"] = "ALREADY_ANSWERED";
    FrontendAdcOverrideError["INCORRECT_SSN"] = "INCORRECT_SSN";
    FrontendAdcOverrideError["INCORRECT_SSN_CARD_FROZEN"] = "INCORRECT_SSN_CARD_FROZEN";
    FrontendAdcOverrideError["MISSING_SSN"] = "MISSING_SSN";
    FrontendAdcOverrideError["NOT_FOUND"] = "NOT_FOUND";
    FrontendAdcOverrideError["INTERVENING_MESSAGE_SENT"] = "INTERVENING_MESSAGE_SENT";
    FrontendAdcOverrideError["TYPE_IS_FYI_ONLY"] = "TYPE_IS_FYI_ONLY";
    FrontendAdcOverrideError["NON_OVERRIDABLE"] = "NON_OVERRIDABLE";
    FrontendAdcOverrideError["UNKNOWN_RESPONSE"] = "UNKNOWN_RESPONSE";
})(FrontendAdcOverrideError || (exports.FrontendAdcOverrideError = FrontendAdcOverrideError = {}));
